import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const PriceSectionStyles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 24px;
	background: #0000000d;
	justify-content: flex-end;

	.price-content {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		column-gap: 32px;
		row-gap: 4px;

		${breakPoints({
			'768': `
				flex-direction: row;
			`,
		})}
	}
`;

export const ButtonSectionStyles = styled.div`
	display: flex;
	flex-direction: column-reverse;
	justify-content: flex-end;
	gap: 4px;

	${breakPoints({
		'768': `
			flex-direction: row;
		`,
	})}
`;
